<template>
  <nav class="adm-pagination" aria-label="Paginación">
    <AdmButton
      variant="secondary"
      size="sm"
      :icon="ChevronLeft"
      :disabled="page <= 1"
      @click="$emit('update:page', page - 1)"
    >
      Anterior
    </AdmButton>

    <span class="adm-pagination__info">
      Página {{ page }} de {{ safeTotalPages }}
      <span v-if="totalItems !== null" class="adm-muted">· {{ totalItems }} registros</span>
    </span>

    <AdmButton
      variant="secondary"
      size="sm"
      :disabled="page >= safeTotalPages"
      @click="$emit('update:page', page + 1)"
    >
      Siguiente
      <ChevronRight :size="15" />
    </AdmButton>
  </nav>
</template>

<script>
/** Paginador del panel — plan 27_09_2026 §4.2. */
import { computed } from 'vue';
import { ChevronLeft, ChevronRight } from 'lucide-vue-next';
import AdmButton from './AdmButton.vue';

export default {
  name: 'AdmPagination',
  components: { AdmButton, ChevronRight },
  props: {
    page: { type: Number, required: true },
    totalPages: { type: Number, default: 1 },
    totalItems: { type: Number, default: null },
  },
  emits: ['update:page'],
  setup(props) {
    // Con 0 resultados el backend puede devolver totalPages = 0; mostrar
    // "Página 1 de 0" es confuso, así que el mínimo es 1.
    const safeTotalPages = computed(() => Math.max(1, props.totalPages || 1));
    return { safeTotalPages, ChevronLeft, ChevronRight };
  },
};
</script>

<style scoped>
.adm-pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--adm-gap);
  flex-wrap: wrap;
  padding: var(--adm-gap-sm) 0;
}

.adm-pagination__info {
  font-family: var(--font-body);
  font-size: var(--adm-font-sm);
  color: var(--color-text-strong);
}
</style>
